import React from 'react';
import { DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import P from '@leverege/promise';
import { connect } from 'react-redux';
import { Blocker } from '@leverege/molten/views';
import { Text } from '@leverege/ui-elements';
import { GroupActions, ItemActions } from '@leverege/molten/imagine';
import { formatCurrency } from '../../../util/Formatting';
import { jsx as _jsx } from "react/jsx-runtime";
class AddendumChargesRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.initialLoad = P.deferred();
  }
  componentDidMount() {
    this._isMounted = true;
    const {
      addendumActions
    } = this.props;
    GlobalState.dispatch(addendumActions.search({
      limit: 0,
      aggs: {
        charges: {
          type: 'stats',
          field: 'data/amount'
        }
      },
      filter: {
        field: 'data/type',
        type: 'equals',
        value: 'charge'
      }
    }, {
      ttl: 30000
    })).then(res => {
      this.initialLoad.resolve();
    });
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  renderChildren = () => {
    const {
      aggs,
      variant
    } = this.props;
    return /*#__PURE__*/_jsx(Text, {
      variant: variant,
      children: formatCurrency(aggs?.charges?.sum || 0)
    });
  };
  render() {
    const matchContext = {
      client: 'AddendumChargesRenderer'
    };
    return /*#__PURE__*/_jsx(Blocker, {
      matchContext: matchContext,
      context: this.props,
      hooks: [{
        execute: () => this.initialLoad
      }],
      render: this.renderChildren,
      small: true,
      loadingProps: {
        inline: true
      }
    });
  }
}
export default connect((state, ownProps) => {
  const {
    original,
    context
  } = ownProps;
  const itemActions = context?.clientProps?.actions instanceof ItemActions ? context?.clientProps?.actions : null;
  const billActions = itemActions || DataSources.getActions(original);
  const childActions = billActions.child('addendum');
  const addendumActions = new GroupActions({
    match: childActions.match,
    relationship: childActions.relationship,
    queryName: 'totalAddendumChargesAgg'
  });
  const aggs = addendumActions.getList(state, {
    getAll: true
  })?.aggs;
  return {
    models: state.models,
    addendumActions,
    aggs
  };
})(AddendumChargesRenderer);